import { ObjectId } from 'bson';

import { moment, TimeFormat } from '@feathr/hooks';

/**
 * Derives an ISO date-time string from the timestamp prefix of a MongoDB
 * ObjectId. The API often omits a dedicated created timestamp because the
 * document id already encodes it; models expose it as a `dateCreated` getter.
 */
export function isoTimestampFromObjectId(id: string): string {
  return moment.utc(new ObjectId(id).getTimestamp()).format(TimeFormat.isoDateTime);
}
